'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index$1 = require('../../../components/Language/index.js');
var index$2 = require('../../../components/ComponentInsertion/index.js');
require('../../../components/Spinner/index.js');
require('../../../components/Button/styles.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/index.js');
require('../../../components/PudoCard/index.js');
require('../../../components/ItemCard/index.js');
require('../../../components/SelectItem/index.js');
require('../../../components/SelectList/index.js');
var index = require('../../../components/ErrorBanner/index.js');
require('../../../components/Footer/index.js');
require('../../../components/StickyFooter/index.js');
require('../../../components/SwatchesList/index.js');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/index.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/ItemCardSkeleton.js');
require('../../../components/Skeleton/LineItemSkeleton.js');
require('../../../components/Skeleton/PudoCardSkeleton.js');
var styles = require('./styles.js');
var useLanguage = require('../../../hooks/useLanguage.js');
var index$3 = require('../../../components/PickerBlock/index.js');
var useReturns = require('../../../hooks/useReturns.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const HandoffForm = _ref => {
  let {
    handoffTypes = [],
    onChange
  } = _ref;
  if (handoffTypes.length === 0) return null;
  const items = handoffTypes.map(handoffType => ({
    value: handoffType,
    label: /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      langKey: `returnsPudoPickupInstructionsHandoff${handoffType}`,
      defaultString: handoffType.replace('_', ' ').toLowerCase(),
      style: {
        textTransform: 'capitalize'
      }
    })
  }));
  const handleChange = key => {
    onChange === null || onChange === void 0 ? void 0 : onChange(key);
  };
  return /*#__PURE__*/React__default["default"].createElement(styles.PickupHandoffWrapper, null, /*#__PURE__*/React__default["default"].createElement(styles.PickupHandoffTitle, null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoPickupInstructionsHandoffTitle"
  })), /*#__PURE__*/React__default["default"].createElement(index$3.PickerBlock, {
    items: items,
    onChange: handleChange
  }));
};
const PickupInstructions = _ref2 => {
  var _pickup$customerInstr;
  let {
    pickup,
    handlePickupLocationValueChange
  } = _ref2;
  const [instructionsVisible, setInstructionsVisible] = React.useState(false);
  const {
    rawValue
  } = useLanguage["default"]({
    langKey: 'returnsPudoPickupInstructionsPlaceholder',
    asString: true
  });
  const handleInstructionsToggle = () => {
    setInstructionsVisible(!instructionsVisible);
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(styles.PickupLocationToggle, {
    onClick: handleInstructionsToggle
  }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoPickupInstructionsToggle"
  })), instructionsVisible && /*#__PURE__*/React__default["default"].createElement(styles.PickupLocationInputWrapper, null, /*#__PURE__*/React__default["default"].createElement(styles.PickupLocationInput, {
    placeholder: rawValue,
    maxLength: 90,
    value: (pickup === null || pickup === void 0 ? void 0 : pickup.customerInstructions) || '',
    onChange: handlePickupLocationValueChange,
    role: "textbox"
  }), /*#__PURE__*/React__default["default"].createElement(styles.Counter, null, `${(pickup === null || pickup === void 0 ? void 0 : (_pickup$customerInstr = pickup.customerInstructions) === null || _pickup$customerInstr === void 0 ? void 0 : _pickup$customerInstr.length) || 0}/90`)));
};
const HomePickupForm = _ref3 => {
  let {
    onChangePickupInstructions,
    onChangeHandoffSelection,
    onChangePickupTimeSlot,
    onChange,
    availablePickup,
    selectedPickup,
    address
  } = _ref3;
  const [pickup, setPickup] = React.useState(selectedPickup);
  const setInitialPickup = () => {
    if (!availablePickup) {
      setPickup(undefined);
      return;
    }
    const data = {
      selectedTimeSlot: availablePickup.timeSlots[0]
    };
    onChangePickupTimeSlot === null || onChangePickupTimeSlot === void 0 ? void 0 : onChangePickupTimeSlot(data);
    setPickup(data);
  };
  const setInitialPickupRef = React.useRef(setInitialPickup);
  React.useEffect(() => setInitialPickupRef.current(), []);
  const {
    localeCountry,
    localeLanguage
  } = useReturns["default"]();
  const localeConversion = `${localeLanguage}-${localeCountry}`;
  if (!availablePickup) return null;
  if (!availablePickup.timeSlots || availablePickup.timeSlots.length === 0) {
    return /*#__PURE__*/React__default["default"].createElement(index["default"], null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      langKey: "returnsPudoErrorNotimeslots"
    }));
  }
  const handlePickupLocationValueChange = e => {
    if (!pickup) return;
    const data = {
      ...pickup,
      customerInstructions: e.target.value || (pickup === null || pickup === void 0 ? void 0 : pickup.customerInstructions)
    };
    onChangePickupInstructions === null || onChangePickupInstructions === void 0 ? void 0 : onChangePickupInstructions(data);
    onChange === null || onChange === void 0 ? void 0 : onChange(data);
    setPickup(data);
  };
  const handleHandoffValueChange = key => {
    if (!pickup) return;
    const data = {
      ...pickup,
      selectedHandoff: key
    };
    onChange === null || onChange === void 0 ? void 0 : onChange(data);
    onChangeHandoffSelection === null || onChangeHandoffSelection === void 0 ? void 0 : onChangeHandoffSelection(data);
    setPickup(data);
  };
  const timeDateTokens = {
    earliestHour: new Intl.DateTimeFormat(localeConversion, {
      hour: 'numeric',
      minute: 'numeric'
    }).format(new Date(availablePickup.timeSlots[0].earliestArrival)),
    latestHour: new Intl.DateTimeFormat(localeConversion, {
      hour: 'numeric',
      minute: 'numeric'
    }).format(new Date(availablePickup.timeSlots[0].latestArrival)),
    day: new Intl.DateTimeFormat(localeConversion, {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    }).format(new Date(availablePickup.timeSlots[0].earliestArrival))
  };
  return /*#__PURE__*/React__default["default"].createElement(styles.PickupWrapper, null, /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    area: "homePickup",
    position: "head"
  }), /*#__PURE__*/React__default["default"].createElement(styles.TimeslotTitle, null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoPickupTimeslotTitle",
    replacementTokens: useLanguage.generateTokensFromObject(timeDateTokens)
  })), /*#__PURE__*/React__default["default"].createElement(styles.TimeslotDate, null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoPickupTimeslotDate",
    replacementTokens: useLanguage.generateTokensFromObject(timeDateTokens),
    defaultString: timeDateTokens.day
  })), /*#__PURE__*/React__default["default"].createElement(styles.TimeslotDescription, null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoPickupTimeslotDescription",
    replacementTokens: useLanguage.generateTokensFromObject(timeDateTokens)
  })), /*#__PURE__*/React__default["default"].createElement(styles.Divider, null), /*#__PURE__*/React__default["default"].createElement(styles.PickupLocationTitle, null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoPickupLocationTitle"
  })), /*#__PURE__*/React__default["default"].createElement(styles.PickupLocationDescription, null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoPickupLocationDescription"
  })), address && /*#__PURE__*/React__default["default"].createElement(styles.PickupLocationAddress, null, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    langKey: "returnsPudoPickupLocationAddress",
    defaultString: [address.address1, address.address2 && `<br/>${address.address2}`, `<br/>`, `${address.city},`, `${address.regionCode}`, `${address.postalCode}`].join(' '),
    replacementTokens: useLanguage.generateTokensFromObject({
      ...address
    })
  })), /*#__PURE__*/React__default["default"].createElement(HandoffForm, {
    onChange: handleHandoffValueChange,
    handoffTypes: (availablePickup === null || availablePickup === void 0 ? void 0 : availablePickup.handoffTypes) || []
  }), /*#__PURE__*/React__default["default"].createElement(PickupInstructions, {
    pickup,
    handlePickupLocationValueChange
  }), null, /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    area: "homePickup",
    position: "foot"
  }));
};

exports["default"] = HomePickupForm;
